import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cancelButtonText", "handleCancelClick"],
    _excluded2 = ["cancelButtonText", "handleCancelClick", "searchPlaceHolder", "searchValue", "handleSearchChange", "inputProps", "focusInputOnMount"];
import React, { useEffect, useRef } from "react";
import { useThemeDefaults } from "../utils";
import styled from "styled-components";
import Box from "../Box";
import { Text as TextInput } from '../Input';
import SearchAltIcon from '../Icons/SearchAltIcon';
import Breakpoint from '../Breakpoint';
import Link from '../Link';
import Text from '../Text';
export var CancelButton = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.tableSearch.cancelButton.margin
  };
}, function (props) {
  var cancelButtonText = props.cancelButtonText,
      handleCancelClick = props.handleCancelClick,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "span",
    textStyle: ['bodyViewSRegular', 'bodyRegular']
  }, rest), /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: handleCancelClick
  }, cancelButtonText));
});

var SearchWrapper = function SearchWrapper(props) {
  return /*#__PURE__*/React.createElement(Breakpoint, {
    ssr: true
  }, function (_ref2) {
    var bpName = _ref2.bpName;
    return bpName === 'sm' ? /*#__PURE__*/React.createElement(SmallViewSearch, props) : /*#__PURE__*/React.createElement(LargeViewSearch, props);
  });
};

var SmallViewSearch = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    width: theme.tableSearch.smallViewSearch.width
  };
}, styled(Box).withConfig({
  displayName: "TableSearch__SmallViewSearch",
  componentId: "sc-1twtvg8-0"
})(["& svg{left:10px;}& button{right:10px;}"]));
var LargeViewSearch = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    width: theme.tableSearch.largeViewSearch.width
  };
}, styled(Box).withConfig({
  displayName: "TableSearch__LargeViewSearch",
  componentId: "sc-1twtvg8-1"
})(["& svg{left:8px;}& button{right:8px;}"]));
export var TableSearch = useThemeDefaults(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: 'flex',
    justifyContent: theme.tableSearch.justifyContent,
    alignItems: theme.tableSearch.alignItems
  };
}, function (props) {
  var cancelButtonText = props.cancelButtonText,
      handleCancelClick = props.handleCancelClick,
      searchPlaceHolder = props.searchPlaceHolder,
      searchValue = props.searchValue,
      handleSearchChange = props.handleSearchChange,
      inputProps = props.inputProps,
      focusInputOnMount = props.focusInputOnMount,
      rest = _objectWithoutProperties(props, _excluded2);

  var inputRef = useRef(null);
  useEffect(function () {
    if (!focusInputOnMount) {
      return;
    }

    setTimeout(function () {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }, 0);
  }, [focusInputOnMount]);
  return /*#__PURE__*/React.createElement(Box, rest, /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(TextInput, _extends({
    ref: inputRef,
    type: "text",
    IconComponent: SearchAltIcon,
    clearable: true,
    placeholder: searchPlaceHolder,
    value: searchValue,
    onChange: handleSearchChange
  }, inputProps))), cancelButtonText && /*#__PURE__*/React.createElement(CancelButton, {
    cancelButtonText: cancelButtonText,
    handleCancelClick: handleCancelClick
  }));
});
TableSearch.CancelButton = CancelButton;
export default TableSearch;